/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";

//COMPONENTS MUI
import Collapse from '@mui/material/Collapse';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import IconButton from '@mui/material/IconButton';


function Instructions({instructions, activarSliderInst}){
    
    React.useEffect(() => {
        setSlider(activarSliderInst);
      }, [activarSliderInst]);

    //eslint-disable-next-line
    const [slider, setSlider] = React.useState(false);

    const [iconSlider, setIconSlider] = React.useState(false);
    
    const DirectionsClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setSlider(false);
        setIconSlider(true);
    };
    
    const DirectionsOpen = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSlider(true);
        setIconSlider(false);
    };
    return(
        <div>
            <Collapse orientation="horizontal" in={instructions.length >= 1 ? slider : null} sx={{position: 'absolute', zIndex:1, height: '50vh'}}>
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={DirectionsClose}
                    sx={{backgroundColor: 'white', position: 'absolute', mt: '25vh', ml: '35vw'}}
                >
                    <ArrowBackIosIcon fontSize="small" color="black" />
                </IconButton>
                <div className="scroll-directions">
                    {instructions.map((instruction, id) => (
                            <div key={id}><p style={{zIndex:20, marginRight:'10px'}} dangerouslySetInnerHTML={{ __html: instruction }} /></div>
                            ))}
                </div>
            </Collapse>
            <Collapse orientation="horizontal" in={iconSlider} sx={{position: 'absolute', zIndex:1, height: '50vh'}}>
                <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={DirectionsOpen}
                sx={{backgroundColor: 'white', mt: '25vh', position: 'absolute'}}
                >
                    <ArrowForwardIosIcon fontSize="small" color="black" />
                </IconButton>
            </Collapse>
        </div>
    );
}

export default Instructions;